export const materialsSelector = (state) => state.materials?.materials;
export const loadingMaterialsSelector = (state) => state.materials?.loading;
